import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["disclosure", "form"]

  connect() {
    // If a badge is already visible (promo applied from session), keep form hidden
    if (this.element.querySelector("[data-promo-badge]")) {
      this.hideDisclosure()
      this.hideForm()
    }
  }

  disconnect() {
    // Cleanup: reset visibility
  }

  toggle() {
    this.hideDisclosure()
    this.showForm()
  }

  hideDisclosure() {
    if (this.hasDisclosureTarget) {
      this.disclosureTarget.classList.add("hidden")
    }
  }

  showForm() {
    if (this.hasFormTarget) {
      this.formTarget.classList.remove("hidden")
    }
  }

  hideForm() {
    if (this.hasFormTarget) {
      this.formTarget.classList.add("hidden")
    }
  }
}
